import React from 'react';

import FormChangesBlade from './FormChangesBlade';
import SelectedSubGrids from './SelectedSubGrids';
import CustomLoader from '../../components/CustomLoader';
import { FORM_KEYS } from '../constants/form-manager.constants';
import { FormContext } from '../context';
import ValueOverrideController from '../controllers/ValueOverrideController';
import FormManager from '../FormManager';

const DetailForm = ({ isLoading, isTrainerSignOff = false }) => {
  if (isTrainerSignOff) {
    return null;
  }

  return isLoading ? (
    <CustomLoader />
  ) : (
    <FormContext.Provider value={FORM_KEYS.DETAIL}>
      <FormManager isDetail />
      <ValueOverrideController />
      <SelectedSubGrids />
      <FormChangesBlade />
    </FormContext.Provider>
  );
};

export default DetailForm;
